import React from 'react';
import { Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-12 pb-6" data-id="element-85">
      <div className="container mx-auto px-4" data-id="element-86">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-87">
          <div data-id="element-88">
            <h3 className="text-xl font-bold mb-4" data-id="element-89">New Louzan</h3>
            <p className="text-gray-400 mb-4" data-id="element-90">
              Professional building maintenance services for residential and
              commercial properties in Ajman and Dubai.
            </p>
            <div className="flex space-x-4" data-id="element-91">
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-92">
                <Facebook size={20} data-id="element-93" />
              </a>
              <a href="https://www.instagram.com/louzan.bm?igsh=NzBpcWxtZTlwNnJn" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-94">
                <Instagram size={20} data-id="element-95" />
              </a>
              <a href="https://www.tiktok.com/@louzan.bm?_t=ZS-90ZS385M6Eb&_r=1" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-96">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-97">
                  <path d="M9 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8z" data-id="element-98" />
                  <path d="M16 8v8" data-id="element-99" />
                  <path d="M12 16v4" data-id="element-100" />
                  <path d="M20 12V8h-4" data-id="element-101" />
                  <path d="M16 4v4" data-id="element-102" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-103">
                <Twitter size={20} data-id="element-104" />
              </a>
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-105">
                <Linkedin size={20} data-id="element-106" />
              </a>
            </div>
          </div>
          <div data-id="element-107">
            <h3 className="text-xl font-bold mb-4" data-id="element-108">Our Services</h3>
            <ul className="space-y-2" data-id="element-109">
              <li data-id="element-110">
                <a href="#services" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-111">
                  Ceiling & Walls Maintenance
                </a>
              </li>
              <li data-id="element-112">
                <a href="#services" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-113">
                  Flooring & Tiling Work
                </a>
              </li>
              <li data-id="element-114">
                <a href="#services" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-115">
                  Electrical & Wiring Services
                </a>
              </li>
              <li data-id="element-116">
                <a href="#services" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-117">
                  Plumbing & Water Systems
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-118">
            <h3 className="text-xl font-bold mb-4" data-id="element-119">Quick Links</h3>
            <ul className="space-y-2" data-id="element-120">
              <li data-id="element-121">
                <a href="#home" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-122">
                  Home
                </a>
              </li>
              <li data-id="element-123">
                <a href="#about" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-124">
                  About Us
                </a>
              </li>
              <li data-id="element-125">
                <a href="#services" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-126">
                  Services
                </a>
              </li>
              <li data-id="element-127">
                <a href="#contact" className="text-gray-400 hover:text-amber-400 transition-colors" data-id="element-128">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-129">
            <h3 className="text-xl font-bold mb-4" data-id="element-130">Contact Info</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-131">
              <li data-id="element-132">Al Jerf 3, Ajman, UAE</li>
              <li data-id="element-133">+971 50 758 3460</li>
              <li data-id="element-134">+971 56 867 1672</li>
              <li data-id="element-135">louzan.bm@gmail.com</li>
              <li data-id="element-136">Working Hours: 8AM - 8PM</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-6" data-id="element-137">
          <p className="text-center text-gray-500" data-id="element-138">
            © {new Date().getFullYear()} New Louzan Building Maintenance. All
            Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
}